import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable()
export class MainInterceptorInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const modifiedRequest = request.clone({
    //  headers: request.headers.delete('Authorization')
    });

    return next.handle(modifiedRequest).pipe(
      tap((event) => {
        // if (event instanceof HttpResponse) {
        // Check the response body for error conditions
        const responseBody = event["body"];
        try {
          if (responseBody!==undefined && 'error_code' in responseBody) {
            if (responseBody.error_code == "err-access-token-05") {
              let logout_url = environment.KC_URL + 'realms/' + environment.KC_REALM + '/protocol/openid-connect/logout?redirect_uri=' + environment.KEYCLOAK_AUTH_ADDRESS_ENC           
              localStorage.clear();
              window.location.replace(logout_url);
            }
          }
        } catch (error) {
          console.log("unhandled error in interceptor")
        }
      
      })
    );
  }
}
